//-------------------------------------------------------------------------------------------------- Imports
import { Button, Typography } from "antd";
import { StyleSheet } from "../StyleSheet";
import { useDispatch, useSelector } from "react-redux";
import { images } from "../routes/ImageRoutes";
import { getStatusConfirmationData, setVisibleFalse } from "../stores/slices/statusConfirmationSlice";
const { Text } = Typography;

export enum Status {
    SUCCESS,
    WARN,
    ERROR
};

//-------------------------------------------------------------------------------------------------- Component
const ModalConfirmationSlice = () => {
    const dispatch = useDispatch();
    const { visible, status, textAnts, subtitle, date, text, plan, state, } = useSelector(getStatusConfirmationData);

    return ((visible) ? (
        <>
            <div style={styles.mainContainer}>
                <div style={styles.cardContainer}>
                    <div style={{
                        ...styles.headerContainer,
                        backgroundColor: status === Status.SUCCESS ? "#ff6b00" : status === Status.ERROR ? "#e20514" : "#e8b031"
                    }}>
                        <img
                            src={images.alertMegamovil}
                            alt="mega-logo"
                            style={styles.imageLogo}
                        />
                    </div>
                    <div style={styles.bodyContainer}>
                        <Text style={{ ...styles.textSubtitle, fontSize: 18, fontWeight: 500 }}>
                            {textAnts}
                        </Text>
                        <Text style={{ color: "#767a85", fontSize: 16, marginTop: 8 }}>
                            {subtitle}
                        </Text>
                        <Text style={{ color: "#767a85", fontSize: 16, fontWeight: 600 }}>
                            {date}
                        </Text>
                        <Text style={{ color: "#767a85", fontSize: 16, marginTop: 15 }}>
                            {text}
                        </Text>
                        <Text style={{ color: "#767a85", fontSize: 16, fontWeight: 600 }}>
                            {plan}
                        </Text>
                        <h2 style={{ color: status === Status.SUCCESS ? "#ff6b00" : status === Status.ERROR ? "#e20514" : "#e8b031" }}>
                            {state}
                        </h2>
                    </div>
                </div>
                <div style={styles.buttonsContainer}>
                    <Button
                        style={styles.buttonStyle}
                        onClick={() => dispatch(setVisibleFalse())}
                    >
                        Finalizar
                    </Button>
                </div>
            </div>
        </>
    ) : (
        null
    ));
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    mainContainer: {
        position: "absolute",
        display: "flex",
        width: "100%",
        height: "100%",
        zIndex: 100,
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgb(0 0 0 / 60%)",
    },
    cardContainer: {
        width: 400,
        borderRadius: "15px",
    },
    headerContainer: {
        display: "flex",
        width: "100%",
        height: 150,
        borderRadius: "15px 15px 0px 0px",
        alignItems: "center",
        justifyContent: "center",
    },
    bodyContainer: {
        display: "flex",
        flexDirection: "column",
        padding: "40px 20px 40px 20px",
        borderRadius: "0px 0px 15px 15px",
        alignItems: "center",
        textAlign: "center",
        justifyContent: "center",
        backgroundColor: "#ffffff",
    },
    buttonsContainer: {
        display: "flex",
        width: 450,
        padding: "40px 0px 40px 0px",
        alignItems: "center",
        justifyContent: "center",
    },
    buttonStyle: {
        height: 40,
        fontSize: 18,
        fontWeight: 600,
        padding: "0px 40px 0px 40px",
        borderRadius: 20,
        border: "none",
        color: "#ffffff",
        backgroundColor: "#0055c2",
    },
    imageLogo: {
        maxHeight: 100,
        maxWidth: "100%",
        marginTop: 40,
        marginBottom: 15
    },
    textSubtitle: {
        color: "#767a85",
        fontSize: 17,
        marginTop: 15,

    },
    textTitle: {
        marginTop: 10,
        fontSize: 20,
    },
});

//-------------------------------------------------------------------------------------------------- Exports
export default ModalConfirmationSlice;